module.exports = __webpack_public_path__ + "static/img/zyjb.c214838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/appModule/bouncedMormApp/img/zyjb.jpg
// module id = NZCO
// module chunks = 1